import { options } from 'common/components/ContentEditor/options';
import { useContentEditor } from 'common/components/ContentEditor/hooks/useContentEditor';
import {
    IToolbarButtonProps,
    ToolbarButton,
} from 'common/components/ContentEditor/components/EditorToolbar/ToolbarButton';

import { EmbedDialog } from './EmbedDialog';
import { useEmbedDialogState } from './useEmbedDialogState';

interface IProps extends IToolbarButtonProps {
    media_embed?: typeof options.media_embed;
}

export const ToolbarEmbed = ({
    media_embed = options.media_embed,
    ...other
}: IProps) => {
    const editor = useContentEditor();
    const { open, initialValue, onTrigger, onClose, onSubmit } =
        useEmbedDialogState(editor);

    return (
        <>
            <ToolbarButton
                active={editor.api.some({ match: { type: media_embed.type } })}
                onMouseDown={(event) => {
                    event.preventDefault();
                    onTrigger();
                }}
                {...other}
            />
            <EmbedDialog
                initialValue={initialValue}
                open={open}
                onClose={onClose}
                onSubmit={onSubmit}
            />
        </>
    );
};
